(function() {
  'use strict';

  AddUserGroupDialogController.$inject = ['onSuccessfulEdit', 'user', '$uibModalInstance', 'availableGroups', '$filter'];

  function AddUserGroupDialogController (onSuccessfulEdit, user, $uibModalInstance, availableGroups, $filter) {
    var ctrl = this;

    ctrl.$onInit = function() {

      ctrl.serverMessage = undefined;
      ctrl.user = user.value;
      ctrl.onSuccessfulEdit = onSuccessfulEdit.value;

      ctrl.availableGroups = filterGroups(availableGroups, ctrl.user.userGroups);
    }

    function filterGroups(availableGroups, filterGroups) {
      var filtered = [];
      for (var arr in availableGroups) {
        var found = false;
        for (var filter in filterGroups) {
          if (filterGroups[filter].id === availableGroups[arr].id) {
            found = true;
            break;
          }
        };
        if (!found) filtered.push(availableGroups[arr]);
      };

      return filtered;
    }

    ctrl.clear = function() {
      $uibModalInstance.dismiss('cancel');
    }

    ctrl.save = function() {
      ctrl.isSaving = true;

      ctrl.onSuccessfulEdit({
        userGroup: ctrl.userGroup,
      })
        .then(onSaveSuccess)
        .catch(onSaveError)
        .finally(function() {
          ctrl.isSaving = false;
        });
    }

    function onSaveSuccess (result) {
      $uibModalInstance.close(result);
    }

    function onSaveError (reason) {
      ctrl.serverMessage = reason.data.message;
    }

  }

  angular
    .module('tyallsApp')
    .controller('AddUserGroupDialogController', AddUserGroupDialogController);
})();
